// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"734dc6d9","248":"ef452c94","597":"9cca7383","962":"af405269"}[chunkId] + ".chunk.css";
};